import { faCalendarDays, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Nav, Row, Tab, } from "react-bootstrap";
import Select from 'react-select';


const StaffFilterModal = (props) => {

    return (
        <div>
            <Modal show={props.show} onHide={props.close} centered className="staff_filter_modal">
                <Modal.Header closeButton>
                    <Modal.Title>Filter</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="filter_details">
                        <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                            <Row>
                                <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={5}>
                                    <Nav variant="pills" className="flex-column">
                                        <Nav.Item>
                                            <Nav.Link eventKey="first">Deparment</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="second">Role</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="third">Hospital Name</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="fourth">Status</Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={7}>
                                    <div className="content_area">
                                        <Tab.Content>
                                            <Tab.Pane eventKey="first">
                                                <div className="dropdown_box">
                                                    <h6>Department</h6>
                                                    <div className="dropdown_area">
                                                        <Select
                                                            autoFocus={false}
                                                            placeholder={'Department Name'}
                                                        // options={""}
                                                        />
                                                    </div>
                                                </div>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="second">
                                                <div className="check_boxes">
                                                    <Form>
                                                        {['radio'].map((type) => (
                                                            <div key={type} className="mb-3">
                                                                <Form.Check type={type} id={`check-api-${type}`}>
                                                                    <Form.Check.Input type={type} isValid />
                                                                    <Form.Check.Label>Doctor</Form.Check.Label>
                                                                </Form.Check>
                                                                <Form.Check type={type} id={`check-api-${type}`}>
                                                                    <Form.Check.Input type={type} isValid />
                                                                    <Form.Check.Label>Nurse</Form.Check.Label>
                                                                </Form.Check>
                                                                <Form.Check type={type} id={`check-api-${type}`}>
                                                                    <Form.Check.Input type={type} isValid />
                                                                    <Form.Check.Label>Receptionist</Form.Check.Label>
                                                                </Form.Check>
                                                            </div>
                                                        ))}
                                                    </Form>
                                                </div>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="third">
                                                <div className="dropdown_box">
                                                    <h6>Hospital Name</h6>
                                                    <div className="dropdown_area">
                                                        <Select
                                                            autoFocus={false}
                                                            placeholder={'Oxford Hospital'}
                                                        // options={""}
                                                        />
                                                    </div>
                                                </div>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="fourth">
                                                <div className="check_boxes">
                                                    <Form>
                                                        {['radio'].map((type) => (
                                                            <div key={type} className="mb-3">
                                                                <Form.Check type={type} id={`check-api-${type}`}>
                                                                    <Form.Check.Input type={type} isValid />
                                                                    <Form.Check.Label>Active</Form.Check.Label>
                                                                </Form.Check>
                                                                <Form.Check type={type} id={`check-api-${type}`}>
                                                                    <Form.Check.Input type={type} isValid />
                                                                    <Form.Check.Label>Deactivated</Form.Check.Label>
                                                                </Form.Check>
                                                            </div>
                                                        ))}
                                                    </Form>
                                                </div>
                                            </Tab.Pane>
                                        </Tab.Content>
                                    </div>
                                </Col>
                            </Row>
                        </Tab.Container>
                        <div className="btn_area">
                            <Button className="cancelBtn" type="button">Clear All</Button>
                            <Button className="submitBtn" type="submit" onClick={() => props.close}>Apply</Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default StaffFilterModal;